















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import mapStore, { State, Search, NodeVo } from '../../../../store/nexus';
import { EDGEMID_MAP } from '../../../../constant';
@Component({
    components: {}
})
export default class Select extends Vue {
    clickId!: any;
    icon: HTMLElement;
    search!: Search;
    keys!: Array<string>;
    checkAll: boolean = false;
    isActive: boolean = false;
    titleList: Array<any> = [];
    checkedList: Array<string> = [];
    searchInput!: HTMLInputElement;
    isIndeterminate: boolean = false;
    dataSource: State = mapStore.dataSource;
    // 记录当前激活之后的操作日志方便之后取消还原
    curLog: {
        checkAll: boolean;
        checkedList: Array<string>;
    } = { checkAll: true, checkedList: [] };
    get title() {
        if (this.checkedList.length) {
            let str: string = this.checkedList
                .map((key: string) => EDGEMID_MAP[key])
                .join(',');
            if (str.length > 16) {
                str = `${str.substring(0, 16)}...`;
            }
            return str;
        }
        return '选择搜索选项';
    }
    checkedTitle(key: string) {
        return EDGEMID_MAP[key] || '未知类型';
    }
    checkAllChange(event: any) {
        const isChecked: boolean = event.target.checked;
        this.checkedList = isChecked ? this.titleList : [];
        this.isIndeterminate = false;
    }
    checkedChange(item: Array<string>) {
        const count: number = item.length;
        this.checkAll = count === this.titleList.length;
        this.isIndeterminate = count > 0 && count < this.titleList.length;
    }
    onUpInput(ev: Event) {
        const dom: HTMLInputElement = ev.target as HTMLInputElement;
        const text: string = dom.value;
        this.titleList = this.keys.filter(
            (key: string) => EDGEMID_MAP[key].indexOf(text) !== -1
        );
        this.checkedList = this.checkAll ? this.titleList : [];
    }
    clickSelect() {
        this.isActive = !this.isActive;
        this.curLog = {
            checkAll: this.checkAll,
            checkedList: [...this.checkedList]
        };
        this.icon.classList.add('cur');
        document.addEventListener('click', this.clickId);
    }
    clickButton(type: string) {
        switch (type) {
        case 'yes':
            mapStore.displaySearch(mapStore.curSubjectId, this.checkedList);
            break;
        case 'no':
            this.checkAll = this.curLog.checkAll;
            this.checkedList = this.curLog.checkedList;
            break;
        default:
            break;
        }
        this.icon.classList.remove('cur');
        document.removeEventListener('click', this.clickId);
        this.isActive = false;
    }
    isSelf(node: HTMLElement, target: HTMLElement) {
        const bit: number = target.compareDocumentPosition(node);
        if (bit === 0 || bit === 10) {
            return true;
        }
        return false;
    }
    onUpSearch() {
        const search: Search = this.dataSource.search;
        this.checkedList = [];
        this.titleList = [];
        this.keys = Object.keys(search);
        this.checkAll = false;
        this.keys.forEach((key: string) => {
            let isChecked: boolean = false;
            const nodes: Array<NodeVo> = search[key];
            const size: number = nodes.length - 1;
            for (let i = 0; i < nodes.length; i++) {
                const node: NodeVo = nodes[i];
                if (node.isDisplay && node.id !== mapStore.rootSubjectId) {
                    isChecked = i === size;
                }
            }
            if (isChecked) {
                this.checkedList.push(key);
            }
            this.titleList.push(key);
            // this.titleList.push({ key, title: EDGEMID_MAP[key] || '未知类型' });
        });
        if (this.checkedList.length === this.titleList.length) {
            this.checkAll = true;
        }
        this.searchInput.value = '';
    }
    mounted() {
        const dom: HTMLElement = this.$refs.select as HTMLElement;
        this.icon = this.$refs.icon as HTMLElement;
        this.searchInput = this.$refs.input as HTMLInputElement;
        this.clickId = (ev: MouseEvent) => {
            if (!this.isSelf(dom, ev.target as HTMLElement)) {
                this.clickButton('no');
                this.icon.classList.remove('cur');
            }
            document.removeEventListener('click', this.clickId);
        };
        mapStore.on(mapStore.EVENT_UP_SEARCH, this.onUpSearch.bind(this));
    }
    beforeDestroy() {
        document.removeEventListener('click', this.clickId);
    }
}
